"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CircleCheck } from "lucide-react";
export default function TheDocmorissPromise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222348" id="the-direct-billing-advantage" className="dark bg-background py-16 md:py-24 border-y border-border/40 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <span className="inline-block text-primary font-medium tracking-widest uppercase text-sm mb-4">
            Insurance Direct Billing Advantage
          </span>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-foreground mb-8 leading-tight">
            Enjoy a Stress-Free Recovery
          </h2>

          <div className="space-y-8">
            <p className="text-lg md:text-xl text-muted-foreground font-sans leading-relaxed max-w-2xl mx-auto">
              Experience the convenience of <span className="text-foreground font-medium">instant processing</span>. 
              We eliminate the hassle of manual claims by submitting your insurance paperwork directly at the time of your appointment.
            </p>

            <div className="bg-card/50 backdrop-blur-sm border border-border/30 rounded-2xl p-8 md:p-10 shadow-xl">
              <p className="text-sm font-medium text-primary uppercase tracking-wider mb-6">
                Supported Major Providers
              </p>
              <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-lg md:text-xl font-serif text-foreground/90">
                <div className="flex items-center gap-2">
                  <CircleCheck className="w-5 h-5 text-primary" />
                  <span>Sun Life</span>
                </div>
                <div className="flex items-center gap-2">
                  <CircleCheck className="w-5 h-5 text-primary" />
                  <span>Manulife</span>
                </div>
                <div className="flex items-center gap-2">
                  <CircleCheck className="w-5 h-5 text-primary" />
                  <span>Canada Life</span>
                </div>
                <div className="flex items-center gap-2">
                  <CircleCheck className="w-5 h-5 text-primary" />
                  <span>Desjardins</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="italic text-muted-foreground">& more</span>
                </div>
              </div>
            </div>

            <p className="text-base md:text-lg text-muted-foreground font-sans italic">
              "We handle the paperwork, you handle the healing—with <span className="text-primary font-semibold not-italic">zero out-of-pocket stress</span>."
            </p>
          </div>
        </div>
      </div>
    </section>;
}